export const useViewedTopicsStore = defineStore('viewed-topics', () => {
  const viewedTopics = ref<Record<string, number>>({})

  function viewTopics(newTopics: string[]) {
    const updatedTopics = { ...viewedTopics.value }

    if (newTopics?.length) {
      newTopics.forEach((topic) => {
        updatedTopics[topic] = updatedTopics[topic]
          ? (updatedTopics[topic] += 1)
          : 1
      })
    }

    viewedTopics.value = updatedTopics
  }

  return {
    viewTopics,
    viewedTopics,
  }
})
